import { useEffect } from "react"
import { useUIStore } from "@store"
import { STORAGE_KEYS } from "@utils/constants"

export const useTheme = () => {
  const { theme, setTheme } = useUIStore()

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
    localStorage.setItem(STORAGE_KEYS.THEME, theme)
  }, [theme])

  useEffect(() => {
    const savedTheme = localStorage.getItem(STORAGE_KEYS.THEME) as "light" | "dark" | null
    if (savedTheme) {
      setTheme(savedTheme)
    } else {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      setTheme(prefersDark ? "dark" : "light")
    }
  }, [setTheme])

  return { theme, setTheme }
}
